export const AUTH_DOMAINS = {
  PRIMARY: "primary",
  MBS: "mbs",
};

export const AUTH_STATUS = {
  LOADING: "loading",
  AUTHENTICATED: "authenticated",
  UNAUTHENTICATED: "unauthenticated",
  NEW_PASSWORD_REQUIRED: "newPasswordRequired",
};

export const ACTIVE_AUTH_STORAGE_KEY = "auth.activeDomain";
export const PRIMARY_AUTH_STORAGE_PREFIX = "CognitoIdentityServiceProvider";
export const MBS_AUTH_STORAGE_PREFIX = "mbs.auth";
export const MBS_SSO_EXPECTED_EMAIL_KEY = "ssoExpectedEmail";
export const MBS_PENDING_AUTH_MESSAGE_KEY = "pendingAuthMessage";

export const MBS_LOGIN_MODE = {
  SSO: "sso",
  LOGIN: "login",
  NEW_PASSWORD: "newPassword",
  FORGOT_PASSWORD: "forgotPassword",
};

export const MBS_OAUTH_RESPONSE_TYPE = "code";
export const MBS_OAUTH_SCOPES = ["openid", "email", "profile"];

export const MBS_AUTH_ERROR_CODES = {
  EXPIRED_CHALLENGE_SESSION: "EXPIRED_CHALLENGE_SESSION",
};

export const EXPIRED_CHALLENGE_SESSION_ERROR =
  "Invalid session for the user, session is expired.";
